module.exports = __webpack_public_path__ + "static/media/closeModal.69fb9888.svg";